/*
 * @Author: jfx
 * @Date: 2022-1-15 16:21:17
 * @LastEditTime: 2022-1-15 16:21:17
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \dtpWeb\src\assets\js\dtpLabel.js
 */
import Vue from 'vue'
import store from "@/store/index.js";
import axios from "axios";
import newReqs from "@/assets/api/newApi";
import commonB from "@/assets/js/common-addition.js";
import {
    reorderCanvasLayer,
    getVetorLayerNode,
    getPageType,
    getChecked,
    stopDrawText,
    getCoordByRowCol,
    getRowCol,
    createPointCanvas,
    isInScale,
    isAddToParams,
    convertMapExtent,
    updateAllChangedData,
    convertLngLat,
    isShowLayer,
    MergeArray
} from "@/assets/js/common.js";
import {
    getGDataObject
} from "@/assets/api/detaildata";

const bus = new Vue()
export default
    {
        /**
         * Label设置数据库类型点转屏位置偏移量
         * @param {} arr
         * @param {*} item
         */
        setAttributeSite(item, type) {
            let esriModule = store.state.esriModule;
            let pts = new esriModule.Point(
                Number(item.x),
                Number(item.y),
                map.spatialReference
            );
            let pt = map.toScreen(pts);
            let rowcol = getRowCol(map.extent);
            let offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
            let offsetX = 0;
            let offsetY = 0;
            if (type === "点") {
                offsetX = offset.offsetX;
                offsetY = offset.offsetY;
            }
            return {
                x: pt.x - offsetX,
                y: pt.y - offsetY,
                label: item.label,

            };
        },

        setAttributeSite2(item, coordinate) {
            let esriModule = store.state.esriModule;
            let orpt = new esriModule.Point(
                Number(item.x),
                Number(item.y),
                new esriModule.SpatialReference(coordinate)
            ),
                pts = convertLngLat(coordinate, orpt),
                pt = map.toScreen(pts),
                rowcol = getRowCol(map.extent),
                offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
            return {
                x: pt.x - offset.offsetX,
                y: pt.y - offset.offsetY,
                label: item.label,
                ID: item.ID,

                layerId: item.layerId,
                screen_x: 0,
                screen_y: 0,
                type: "Vector",
            };
        },

        /**
         * 拖拽处理label数据
         * @param {*} layerId
         * @param {*} data
         * @param {*} type
         */
        appendLabelData(layerId, data, type) {
            return new Promise((resolve, reject) => {
                if (data == null || data.length == 0) {
                    return;
                }
                var esriModule = store.state.esriModule;
                var alllayers = store.state.allLayerData;
                let layer = alllayers.find(x => x.Id == layerId);
                if (layer.Label) {
                    let labels = JSON.parse(layer.Label);
                    if (!labels.Visiable) {
                        return;
                    }
                } else {
                    return;
                }
                var labelObj = labelData.filter(x => x.layerId === layerId);
                let labelIds = [];
                if (labelObj.length > 0) {
                    // labelObj.forEach(item => {
                    //   labelIds.push(item.ID)
                    // })
                    for (let index = 0; index < labelObj.length; index++) {
                        var item = labelObj[index];
                        labelIds.push(item.ID);
                    }
                }
                var label;
                if (layer != undefined) {
                    if (layer.Label != "" && layer.Label != "") {
                        let labelO = JSON.parse(layer.Label);
                        label = labelO.LabelField;
                    }
                }
                // if (!label) {
                //   // throw new Error("GetFiledValueByIDs tagname 为空!");
                //   return;
                // }
                if (type == "Attribute") {
                    commonB.getRenderLabelVals(layerId, data, label, "Attribute", 2)
                        .then(res => {
                            var keys = Object.keys(res);
                            if (data != null) {
                                for (let i = 0; i < data.length; i++) {
                                    var item = data[i];
                                    var index = keys.findIndex(key => key === item.Attr.ID + "");
                                    let labelVal = res[keys[index]];
                                    if (layer.GeoType == "点") {
                                        if (labelIds.indexOf(item.Attr.ID) == -1) {
                                            let orpt = new esriModule.Point(
                                                Number(item.Shape[0][0][0]),
                                                Number(item.Shape[0][0][1]),
                                                map.spatialReference
                                            )
                                            //pts = convertLngLat(obj.coordinate, orpt),
                                            let pt = map.toScreen(orpt)
                                            this.pushLabelData(
                                                layerId,
                                                item.Attr.ID,
                                                pt.x,
                                                pt.y,
                                                labelVal,
                                                type
                                            );
                                        }
                                    } else {

                                        if (labelVal) {
                                            let o = labelVal.split(";");
                                            let position = o[1].split(",");
                                            if (labelIds.indexOf(item.Attr.ID) == -1) {
                                                let orpt = new esriModule.Point(
                                                    Number(position[0]),
                                                    Number(position[1]),
                                                    map.spatialReference
                                                );
                                                this.pushLabelData(
                                                    layerId,
                                                    item.Attr.ID,
                                                    orpt.x,
                                                    orpt.y,
                                                    o[0],
                                                    type
                                                );
                                            }
                                        }
                                    }
                                }
                                resolve(labelData);
                            }
                        });
                } else {
                    commonB.getRenderLabelVals(layerId, data, label, "Vector", 2).then(res => {
                        var keys = Object.keys(res);
                        for (let i = 0; i < data.length; i++) {
                            var item = data[i];
                            var index = keys.findIndex(key => +key === item.O);
                            var labelVal = res[keys[index]];
                            if (labelVal) {
                                if (layer.GeoType == "点") {
                                    if (labelIds.indexOf(item.O) === -1) {
                                        this.pushLabelData(
                                            layerId,
                                            item.O,
                                            0,
                                            0,
                                            labelVal,
                                            type,
                                            item.G[0][0][0],
                                            item.G[0][0][1]
                                        );
                                    }
                                } else {

                                    let o = labelVal.split(";");
                                    let position = o[1].split(",");
                                    if (labelIds.indexOf(item.O) === -1) {
                                        let orpt = new esriModule.Point(
                                            Number(position[0]),
                                            Number(position[1]),
                                            map.spatialReference
                                        );

                                        let pt = map.toScreen(orpt)
                                        //this.pushLabelData(layerId, item.O, orpt.x, orpt.y, o[0], type);
                                        this.pushLabelData(
                                            layerId,
                                            item.O,
                                            0,
                                            0,
                                            o[0],
                                            type,
                                            pt.x,
                                            pt.y
                                        );
                                    }
                                }
                            }
                        }
                        resolve(labelData);
                    });
                }
            });
        },
        UpdateLabelData(labelData, layerId, coordinate) {
            var layerIDIndex = AllChangedData.findIndex(val => val.layerId == layerId)
            if (layerIDIndex == -1)
                return labelData;
            var newlabelData = [];
            for (var i = 0; i < labelData.length; i++) {
                for (var j = 0; j < AllChangedData[layerIDIndex].data.length; j++) {
                    if (labelData[i].ID == AllChangedData[layerIDIndex].data[j].Attr.ID) {
                        var param = {
                            ID: labelData[i].ID,
                            label: labelData[i].label,
                            layerId: labelData[i].layerId,
                            screen_x: 0,
                            screen_y: 0,
                            type: "Attribute",
                            x: AllChangedData[layerIDIndex].data[j].Shape[0],
                            y: AllChangedData[layerIDIndex].data[j].Shape[1]
                        }
                        newlabelData.push(param)
                        //退出这个循环
                        j = AllChangedData[layerIDIndex].data.length - 1
                        continue;
                    }
                    if (j == AllChangedData[layerIDIndex].data.length - 1) {
                        newlabelData.push(labelData[i])
                    }
                }
            }
            return newlabelData
        },
        // 计数刷新标注
        virtuaCoutRefreshLabel(
            layerId,
            data,
            dataType,
            mouseType,
            vectorLayerData
        ) {
            var difference = totalPostCounts - hasPostedCounts;
            if (difference >= -1 && difference == 0) {
                for (let index = 0; index < store.state.allLayerData.length; index++) {
                    const layerInfo = store.state.allLayerData[index];
                    var layerNodes = getVetorLayerNode(store.state.dataTreeData);
                    var nodeIndex = layerNodes.findIndex(node => node.id === layerInfo.Id);
                    let flag = getChecked(layerNodes[nodeIndex], layerInfo);
                    if (flag) {
                        this.DrawLayerLabel(
                            layerInfo.Id,
                            data,
                            dataType,
                            mouseType,
                            vectorLayerData
                        );
                    } else {
                        if (index === store.state.allLayerData.length) stopDrawText();
                    }
                    // }
                }
            } else {
                if (!data.length) {
                    for (let index = 0; index < store.state.allLayerData.length; index++) {
                        const layerInfo = store.state.allLayerData[index];
                        var layerNodes = getVetorLayerNode(store.state.dataTreeData);
                        var nodeIndex = layerNodes.findIndex(node => node.id === layerInfo.Id);
                        let flag = getChecked(layerNodes[nodeIndex], layerInfo);
                        if (flag) {
                            this.DrawLayerLabel(
                                layerInfo.Id,
                                data,
                                dataType,
                                mouseType,
                                vectorLayerData
                            );
                        } else {
                            if (index === store.state.allLayerData.length) stopDrawText();
                        }
                    }
                }
            }
        },

        /**
         * 绘制图层标注，按数据库数据绘制和切片数据绘制,并将标注添加到LabelData
         * @param {*} layerId
         * @param {*} data
         * @param {*} type 数据类型：数据库数据Attribute，切片数据Vector
         * @param {*} flag 鼠标类型：拖拽，缩放
         * @returns
         */
        DrawLayerLabel(layerId, data, type, flag) {
            var layerIDIndex = notDrawIDs.findIndex(val => val.layerId == layerId)
            let willDrawData = [] //将要绘制的数据
    
            //只绘制部分要素图形标注     
            var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
            if (layerInfo != null && layerInfo.VisibleIDs != null && layerInfo.VisibleIDs.length > 0) {
                for (var m = 0; m < data.length; m++) {
                    //只添加要显示的数据
                    if (layerInfo.VisibleIDs.indexOf(data[m].ID) >= 0) {
                        willDrawData.push(data[m])
                    }
                }
            }
            else {
                //剔除已删除数据
                for (var m = 0; m < data.length; m++) {
                    if (layerIDIndex > -1 && notDrawIDs[layerIDIndex].IDs.indexOf(data[m].ID) >= 0)
                        continue
                    willDrawData.push(data[m])
                }
            }
 

            var esriModule = store.state.esriModule;
            let alllayers = store.state.allLayerData;
            let obj = alllayers.find(x => x.Id === layerId);
            if (obj == undefined || obj.Label == "") {
                return;
            }
            let isScale = isInScale(layerId);
            if (!isScale) {
                return;
            }
            let labels = JSON.parse(obj.Label);
            if (!labels.Visiable) {
                return;
            }
            var label = labels.LabelField;

            // 标注存入到labelData里面
            var labelObj = labelData.filter(x => x.layerId === layerId);
            let labelIds = [];
            if (labelObj.length > 0) {
                labelObj.forEach(item => {
                    labelIds.push(item.ID);
                });
            }
            //数据存储
            let list = [];
            //数据库数据
            if (type == "Attribute") {
                if (obj != undefined) {
                    if (obj.Label != "" && obj.Label != null) {
                        let labelO = JSON.parse(obj.Label);
                        label = labelO.LabelField;
                    }
                }

                if (willDrawData != null) {
                    commonB.getRenderLabelVals(layerId, willDrawData, label, type, 2).then(res => {
                        var keys = Object.keys(res);
                        willDrawData.forEach(item => {
                            let index = keys.findIndex(key => key === item.Attr.ID + ""),
                                labelVal = res[keys[index]];
                            if (index > -1) {
                                if (obj.GeoType === "点") {
                                    //点的canvas 比较大，减去多出的部分

                                    item.Shape.forEach((val) => {
                                        let orpt = new esriModule.Point(
                                            Number(item.Shape[0][0][0]),
                                            Number(item.Shape[0][0][1]),
                                            map.spatialReference
                                        ),
                                            //pts = convertLngLat(obj.coordinate, orpt),
                                            pt = map.toScreen(orpt),
                                            rowcol = getRowCol(map.extent),
                                            offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);

                                        list.push({
                                            x: pt.x - offset.offsetX,
                                            y: pt.y - offset.offsetY,
                                            label: res[keys[index]]
                                        });
                                        //存储点在当前地图的地理坐标
                                        this.pushLabelData(layerId, item.Attr.ID, orpt.x, orpt.y, res[keys[index]], type);
                                    })
                                } else {
                                    if (labelVal) {
                                        let o = labelVal.split(";"),
                                            position = o[1].split(","),
                                            orpt = new esriModule.Point(
                                                Number(position[0]),
                                                Number(position[1]),
                                                new esriModule.SpatialReference(obj.coordinate)
                                            ),
                                            pts = convertLngLat(map.spatialReference.wkid, orpt),
                                            pt = map.toScreen(pts);
                                        list.push({
                                            x: pt.x,
                                            y: pt.y,
                                            label: o[0]
                                        });
                                        //存储点在当前地图的地理坐标
                                        this.pushLabelData(
                                            layerId,
                                            item.Attr.ID,
                                            pts.x,
                                            pts.y,
                                            o[0],
                                            type
                                        );
                                    }
                                }
                            }
                        });
                        if (list.length > 0) {
                            this.drawLayerLabelOnCanvas(layerId, list, flag, type);
                        }
                    });
                }
            } else {
                //切片数据
                if (willDrawData != null) {
                    commonB.getRenderLabelVals(layerId, willDrawData, label, type, 2).then(res => {
                        // console.log(data,'获取后数据')
                        // console.log(labelData,'获取后标签数据')                           
                        var keys = Object.keys(res);
                        for (var index = 0; index < willDrawData.length; index++) {
                            var item = willDrawData[index];
                            if (res) {
                                let index = keys.findIndex(key => key === item.O + "");
                                let labelVal = res[keys[index]];
                                if (index > -1) {
                                    if (obj.GeoType == "点") {
                                        list.push({
                                            x: item.G[0][0][0],
                                            y: item.G[0][0][1],
                                            label: labelVal
                                        });
                                        this.pushLabelData(layerId, item.O, 0, 0, labelVal, type, item.G[0][0][0], item.G[0][0][1]);
                                    } else {

                                        if (labelVal) {
                                            let o = labelVal.split(";"),
                                                position = o[1].split(","),
                                                pts = new esriModule.Point(
                                                    Number(position[0]),
                                                    Number(position[1]),
                                                    map.spatialReference
                                                )
                                            let pt = map.toScreen(pts);
                                            list.push({
                                                x: pt.x,
                                                y: pt.y,
                                                label: o[0]
                                            });
                                            //this.pushLabelData(layerId, item.O, pts.x, pts.y, o[0], type);
                                            this.pushLabelData(layerId, item.O, 0, 0, o[0], type, pt.x, pt.y);
                                        }
                                    }
                                }
                            }
                        }
                        if (list.length > 0) {
                            // 初始化的时候边存，边绘制
                            this.drawLayerLabelOnCanvas(layerId, list, flag, type);
                        }
                    });
                }
            }
        },
        /**
         *过滤坐标和标注相同的数据
         */
        labelfilterIdentical(data) {
            ZHT_LabelDrawData = ZHT_LabelDrawData.concat(data);
            ZHT_LabelDrawData = commonB.deteleObject(ZHT_LabelDrawData);
            return ZHT_LabelDrawData
        },
        /**
         * 临时labelcanvas
         * canvas 真实的canvas
         */
        labelTemplabelCanvas(canvas) {
            // var div = document.querySelector("#mapView_gc");
            var templabelCanvas = document.getElementsByClassName("label_temp_canvas");
            // var rowcol = getRowCol(map.extent);
            // var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
            if (templabelCanvas.length) {
                templabelCanvas[0].remove();
            }
            templabelCanvas = document.createElement("canvas");
            templabelCanvas.className = "label_temp_canvas"
            templabelCanvas.height = canvas.height;
            templabelCanvas.width = canvas.width;
            // templabelCanvas.style.left = offset.offsetX + "px";
            // templabelCanvas.style.top = offset.offsetY + "px";
            // templabelCanvas.style.position = "absolute";
            // div.before(templabelCanvas)
            return templabelCanvas
        },
        /**
         * 绘制标注
         * @param {*} layerId
         * @param {*} data
         * @param {*} flag
         */
        drawLayerLabelOnCanvas(layerId, TlabelData, flag, type) {
            // 过滤坐标和标注相同的数据
            var data = [];
            if (flag === "reload" || flag === "init" || flag === "scale") {
                var _data = this.labelfilterIdentical(TlabelData)
                for (let l = 0; l < _data.length; l++) {
                    var _labelVal = _data[l];
                    for (let k = 0; k < TlabelData.length; k++) {
                        var _labelVal2 = TlabelData[k];
                        if (_labelVal2.x === _labelVal.x && _labelVal2.y === _labelVal.y && _labelVal2.label === _labelVal.label) {
                            data.push(_labelVal2)
                        }
                    }
                }
            } else {
                data = commonB.deteleObject(TlabelData);
            }

            var canvas = document.getElementById("labelLayer_" + layerId);
            if (!canvas) {
                this.addLabelCanvas(layerId);
                canvas = document.getElementById("labelLayer_" + layerId);
            }
            var ctx = canvas.getContext("2d");
            var alllayers = store.state.allLayerData;
            var obj = alllayers.find(x => x.Id == layerId);

            if (!obj) return;
            if (obj) {
                if (obj.Label.length > 0) {
                    let labelO = JSON.parse(obj.Label);
                    if (!labelO.Visiable) {
                        return;
                    }
                    let size = labelO.haloSize || 1;
                    let fontsize = labelO.font.size;
                    let weight = labelO.font.weight;
                    if (weight == "bold") {
                        weight = "bolder";
                        fontsize = fontsize + 1;
                    } else {
                        weight = "";
                    }
                    ctx.font = fontsize + "px " + labelO.font.family + " " + weight;

                    let k = 2 * size;
                    let cellw = fontsize + k;
                    let cellh = fontsize; //fontsize - 4
                    // if (fontsize < 16) {
                    //   cellh = fontsize + 4 //fontsize - 2
                    // }
                    let haloColor = "rgba(" + labelO.haloColor.r + "," + labelO.haloColor.g + "," + labelO.haloColor.b + "," +
                        labelO.haloColor.a + ")";
                    ctx.fillStyle = haloColor; //"#FF0000"
                    //符号偏移
                    let ptOffsetX = 0;
                    let ptOffsetY = 0;
                    if (obj.GeoType == "点") {
                        if (obj.Symbol != "") {
                            if (obj.RenderType == "SimpleRender") {
                                var symbols = JSON.parse(obj.Symbol);
                                if (symbols.SymbolType == "Simple") {
                                    ptOffsetX = symbols.Symbol.offsetX ? symbols.Symbol.offsetX : 0;
                                    ptOffsetY = symbols.Symbol.offsetY ? symbols.Symbol.offsetY : 0;
                                }
                            }
                        }
                    }
                    for (let i = 0; i < data.length; i++) {
                        let x =
                            data[i].x +
                            Math.floor(labelO.offsetX ? labelO.offsetX : 0) +
                            ptOffsetX;
                        let y =
                            data[i].y +
                            Math.floor(labelO.offsetY ? labelO.offsetY : 0) +
                            ptOffsetY;
                        if (data[i].label != "" && data[i].label != null) {
                            let txtwidth = ctx.measureText(data[i].label).width + 2 * k;
                            if (obj.GeoType == "点") {
                                x = x - Math.round(txtwidth / 2);
                                y = y - cellh - 2;
                            }
                            //绘制一个圆角矩形
                            this.strokeRoundRect(ctx, x - k, y - k - cellh, txtwidth, cellw, 4);
                            //绘制并填充一个圆角矩形
                            let fillcolor = "rgba(" + labelO.color.r + "," + labelO.color.g + "," + labelO.color.b + "," + labelO.color
                                .a + ")";
                            this.fillRoundRect(ctx, x - k, y - k - cellh, txtwidth, cellw, 4, haloColor);
                            ctx.fillStyle = fillcolor; //"#fff";
                            ctx.fillText(data[i].label, x, y - k / 2 - 1);
                        }
                        if (i === data.length - 1) {
                            stopDrawText();
                        }
                    }
                }
            }

        },

        /**
           * 将labelData里的切片里的标注绘制出来
           * @param {*} layerId
           * @param {*} data
           * @param {*} flag
           */
        drawTilelabelData(layerId) {

            var canvas = document.getElementById("labelLayer_" + layerId);
            if (!canvas) {
                this.addLabelCanvas(layerId);
                canvas = document.getElementById("labelLayer_" + layerId);
            }
            var ctx = canvas.getContext("2d");
            var alllayers = store.state.allLayerData;
            var obj = alllayers.find(x => x.Id == layerId);
            var currentLabelData = labelData.filter(x => x.layerId == layerId)

            if (!obj) return;
            if (obj) {
                if (obj.Label.length > 0) {
                    let labelO = JSON.parse(obj.Label);
                    if (!labelO.Visiable) {
                        return;
                    }
                    let size = labelO.haloSize || 1;
                    let fontsize = labelO.font.size;
                    let weight = labelO.font.weight;
                    if (weight == "bold") {
                        weight = "bolder";
                        fontsize = fontsize + 1;
                    } else {
                        weight = "";
                    }
                    ctx.font = fontsize + "px " + labelO.font.family + " " + weight;

                    let k = 2 * size;
                    let cellw = fontsize + 2 * k;
                    let cellh = fontsize; //fontsize - 4
                    // if (fontsize < 16) {
                    //   cellh = fontsize + 4 //fontsize - 2
                    // }
                    let haloColor = "rgba(" + labelO.haloColor.r + "," + labelO.haloColor.g + "," + labelO.haloColor.b + "," +
                        labelO.haloColor.a + ")";
                    ctx.fillStyle = haloColor; //"#FF0000"
                    //符号偏移
                    let ptOffsetX = 0;
                    let ptOffsetY = 0;
                    if (obj.GeoType == "点") {
                        if (obj.Symbol != "") {
                            if (obj.RenderType == "SimpleRender") {
                                var symbols = JSON.parse(obj.Symbol);
                                if (symbols.SymbolType == "Simple") {
                                    ptOffsetX = symbols.Symbol.offsetX ? symbols.Symbol.offsetX : 0;
                                    ptOffsetY = symbols.Symbol.offsetY ? symbols.Symbol.offsetY : 0;
                                }
                            }
                        }
                    }

                    for (var i = 0; i < currentLabelData.length; i++) {
                        let x =
                            currentLabelData[i].screen_x +
                            Math.floor(labelO.offsetX ? labelO.offsetX : 0) +
                            ptOffsetX;
                        let y =
                            currentLabelData[i].screen_y +
                            Math.floor(labelO.offsetY ? labelO.offsetY : 0) +
                            ptOffsetY;
                        if (currentLabelData[i].label != "" && currentLabelData[i].label != null) {
                            let txtwidth = ctx.measureText(currentLabelData[i].label).width + 2 * k;
                            if (obj.GeoType == "点") {
                                x = x - Math.round(txtwidth / 2);
                                y = y - cellh - 2;
                            }
                            //绘制一个圆角矩形
                            this.strokeRoundRect(ctx, x - k, y - k - cellh, txtwidth, cellw, 4);
                            //绘制并填充一个圆角矩形
                            let fillcolor = "rgba(" + labelO.color.r + "," + labelO.color.g + "," + labelO.color.b + "," + labelO.color
                                .a + ")";
                            this.fillRoundRect(ctx, x - k, y - k - cellh, txtwidth, cellw, 4, haloColor);
                            ctx.fillStyle = fillcolor; //"#fff";
                            ctx.fillText(currentLabelData[i].label, x, y);
                        }
                        if (i === currentLabelData.length - 1) {
                            stopDrawText();
                        }
                    }
                }
            }
        },

        //用以绘制带halo
        /**该方法用来绘制一个有填充色的圆角矩形
         *@param cxt:canvas的上下文环境
         *@param x:左上角x轴坐标
         *@param y:左上角y轴坐标
         *@param width:矩形的宽度
         *@param height:矩形的高度
         *@param radius:圆的半径
         *@param fillColor:填充颜色
         **/
        fillRoundRect(
            cxt,
            x,
            y,
            width,
            height,
            radius,
            /*optional*/
            fillColor
        ) {
            //圆的直径必然要小于矩形的宽高
            if (2 * radius > width || 2 * radius > height) {
                return false;
            }

            cxt.save();
            cxt.translate(x, y);
            //绘制圆角矩形的各个边
            this.drawRoundRectPath(cxt, width, height, radius);
            cxt.fillStyle = fillColor || "#000"; //若是给定了值就用给定的值否则给予默认值
            cxt.fill();
            cxt.restore();
        },

        /**该方法用来绘制圆角矩形
         *@param cxt:canvas的上下文环境
         *@param x:左上角x轴坐标
         *@param y:左上角y轴坐标
         *@param width:矩形的宽度
         *@param height:矩形的高度
         *@param radius:圆的半径
         *@param lineWidth:线条粗细
         *@param strokeColor:线条颜色
         **/
        strokeRoundRect(
            cxt,
            x,
            y,
            width,
            height,
            radius,
            /*optional*/
            lineWidth,
            /*optional*/
            strokeColor
        ) {
            //圆的直径必然要小于矩形的宽高
            if (2 * radius > width || 2 * radius > height) {
                return false;
            }

            cxt.save();
            cxt.translate(x, y);
            //绘制圆角矩形的各个边
            this.drawRoundRectPath(cxt, width, height, radius);
            cxt.lineWidth = lineWidth || 0; //若是给定了值就用给定的值否则给予默认值2
            cxt.strokeStyle = strokeColor || "rgba(255,255,255,0)";
            cxt.stroke();
            cxt.restore();
        },

        drawRoundRectPath(cxt, width, height, radius) {
            cxt.beginPath(0);
            //从右下角顺时针绘制，弧度从0到1/2PI
            cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);
            //矩形下边线
            cxt.lineTo(radius, height);
            //左下角圆弧，弧度从1/2PI到PI
            cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);
            //矩形左边线
            cxt.lineTo(0, radius);
            //左上角圆弧，弧度从PI到3/2PI
            cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);
            //上边线
            cxt.lineTo(width - radius, 0);
            //右上角圆弧
            cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);
            //右边线
            cxt.lineTo(width, height - radius);
            cxt.closePath();
        },
        pushLabelData(layerId, ID, x, y, label, type, screen_x, screen_y) {
            var index = labelData.findIndex(x => x.layerId == layerId && x.ID == ID)
            if (index > -1)
                labelData.splice(index, 1)
            labelData.push({
                layerId: layerId,
                ID: ID,
                x: x, //地理坐标
                y: y, //地理坐标
                label: label,
                type: type,
                screen_x: screen_x,
                screen_y: screen_y
            });
        },
        /**
         * 添加label图层canvas
         * @param {*} layerId 图层Id
         */
        addLabelCanvas(layerId) {
            var div = document.querySelector("#mapView_gc");
            var canvasCtn = document.getElementById("gispaiLayer_labelLayer_" + layerId);
            if (!canvasCtn) {
                canvasCtn = document.createElement("div");
                canvasCtn.id = "gispaiLayer_labelLayer_" + layerId;
                canvasCtn.className = "gispaiLayer_labelLayer";
                canvasCtn.style.position = "absolute";
                div.before(canvasCtn);
            } else {
                canvasCtn.innerHTML = "";
                canvasCtn.style.display = "block";
            }
            var layerInfo = store.state.allLayerData.find(e => e.Id == layerId);
            var canvas = document.getElementById("labelLayer_" + layerId);
            //点全屏
            if (!canvas) {
                canvas = document.createElement("canvas");
                canvas.id = "labelLayer_" + layerId;
                canvas.className = "labelLayer";
                var rowcol = getRowCol(map.extent);
                var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
                if (layerInfo.GeoType == "点") {
                    //点画布大小 
                    var allCol = rowcol.maxCol - rowcol.minCol + 1;
                    var allRow = rowcol.maxRow - rowcol.minRow + 1;
                    canvas.style.left = offset.offsetX + "px";
                    canvas.style.top = offset.offsetY + "px";
                    canvas.width = 256 * allCol;
                    canvas.height = 256 * allRow;
                    canvas.style.position = "absolute";
                    canvasCtn.append(canvas);
                } else {
                    var pdiv = document.querySelector("#mapView");
                    canvas.width = pdiv.clientWidth;
                    canvas.height = pdiv.clientHeight;
                    canvas.style.position = "absolute";
                    canvas.style.left = "0px";
                    canvas.style.top = "0px";
                    canvasCtn.append(canvas);
                }
            }
            reorderCanvasLayer();
            return canvas;
        },
        /**清除该图层所有的label缓存值*/
        clearLabelCacheVals(layerId) {
            LabelIds[layerId] = [];
            LabelVals[layerId] = {};
        },

        /**
         * lebel重置 不变的切片数据
         * @returns
         */
        reSetPointLabel(layerId, rowcol) {
            var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
            if (layerInfo.Label) {
                let labels = JSON.parse(layerInfo.Label);
                if (!labels.Visiable) {
                    return;
                }
            } else {
                return;
            }
            var canvasCtn = document.querySelector(".gispaiLayer_" + layerId);

            //去除范围外的数据切片
            TileData = TileData.filter(
                x =>
                    x.row >= rowcol.minRow &&
                    x.row <= rowcol.maxRow &&
                    x.col >= rowcol.minCol &&
                    x.col <= rowcol.maxCol
            );

            if (layerInfo.GeoType == "点") {
                //点数据优化
                var newPointData = TileData.filter(x => x.layerId == layerId);
                noDrawData = noDrawData.filter(e => e.layerId != layerId);
                createPointCanvas(canvasCtn, rowcol, "gispai", layerId);

                for (var i = 0; i < newPointData.length; i++) {
                    var tempData = labelConvertData(
                        newPointData[i].row,
                        newPointData[i].col,
                        newPointData[i].data,
                        layerInfo.GeoType
                    );
                    this.appendLabelData(layerId, tempData.J, "Vector");
                }
            }
        },

        /**
         * @author: wyt
         * @description:转换数据（点转屏幕） Label数据
         * @param {*} row 行号
         * @param {*} col 列号
         * @param {*} olddata
         * @param {*} geoType 数据类型
         * @return {*}
         */
        labelConvertData(row, col, olddata, geoType) {
            // var data = allData.filter(x=>x.J[i].G != null &&x.J[i].G.length == 0);
            var data = JSON.parse(JSON.stringify(olddata));
            // console.log(data)
            // var data = commonB.deepClone(olddata);
            // var data = olddata;
            var newData = [];
            var obj = {};

            if (data == "") {
                let d = {
                    J: []
                };
                return d;
            }
            if (data.J == null || data.J.length == 0) {
                data.J = [];
                return data;
            }
            for (var i = 0; i < data.J.length; i++) {
                if (data.J[i].G == null || data.J[i].G.length == 0) {
                    continue;
                }
                if (data.J[i].G.length > 0) {
                    var gdata = data.J[i].G;
                    var newd = [];
                    for (var k = 0; k < gdata.length; k++) {
                        var singledata = gdata[k];
                        singledata = singledata.filter(ele => {
                            return ele != null;
                        });
                        if (geoType == "面") {
                            if (singledata.length < 4) {
                                continue;
                            } else {
                                newd.push(singledata);
                            }
                        } else if (geoType == "线") {
                            if (singledata.length < 2) {
                                continue;
                            } else {
                                newd.push(singledata);
                            }
                        } else {
                            var rowcol = getRowCol(map.extent);
                            var pdata = [];
                            for (var j = 0; j < singledata.length; j++) {
                                var x = singledata[j][0] + 256 * (col - rowcol.minCol);
                                var y = singledata[j][1] + 256 * (rowcol.maxRow - row);
                                pdata.push([x, y]);
                            }
                            newd.push(pdata);
                            // newd.push(singledata);
                        }
                    }
                    if (newd.length > 0) { }
                    data.J[i].G = newd;
                }
            }
            return data;
        },

        /**
         * 重新加载lable数据，即重新获取标注位置及标注值
         * @param {*} layerId 图层Id
         */
        reloadLabelData(layerId) {
            //清楚缓存中的标注数据     
            this.clearLabelCacheVals(layerId);
            var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
            var layerTileData = TileData.filter(x => x.layerId == layerId)
            for (var i = 0; i < layerTileData.length; i++) {
                //切片上的坐标转换成canvas上要绘制的坐标
                var newData2 = this.labelConvertData(
                    layerTileData[i].row,
                    layerTileData[i].col,
                    layerTileData[i].data,
                    layerInfo.GeoType
                );
                //开始绘制切片标注
                this.DrawLayerLabel(layerId, newData2.J, "Vector", "scale");
            }
            var alldata = AllChangedData.find(val => val.layerId === layerId)

            var viewdata = alldata.data.filter(ele => ele.IsInView == true);

            //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
            if (viewdata) {
                this.DrawLayerLabel(layerId, viewdata, "Attribute", "scale");
            }
        },
        /**
        * 重新绘制lable数据，仅修改了标注符号后重绘
        * @param {*} layerId 图层Id
        */
        reDrawLabelData(layerId) {
            this.clearLabelCanvas(layerId);
            //绘制还在范围内的标注（数据库数据除外）
            this.drawTilelabelData(layerId);
            var alldata = AllChangedData.find(val => val.layerId === layerId)
            var viewdata = alldata.data.filter(ele => ele.IsInView == true);
            //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
            if (viewdata) {
                this.DrawLayerLabel(layerId, viewdata, "Attribute", "scale");
            }
        },
        clearLabelCanvas(layerId, type) {
            var canvas = document.getElementById("labelLayer_" + layerId);
            if (canvas) {
                var ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        },
        //拖拽的时候清除超出部份标注数据
        clearPointLableData(layerId) {
            var canvas = document.getElementById("labelLayer_" + layerId);
            if (!canvas)
                return;
            var alllayers = store.state.allLayerData;
            let lay = alllayers.find(x => x.Id == layerId);
            if (lay) {
                if (lay.GeoType == "点") {
                    for (var i = 0; i < labelData.length; i++) {
                        if (labelData[i].layerId != layerId)
                            continue
                        var item = labelData[i];
                        if (item.type == "Vector" && (item.screen_x + DragOffsetX > canvas.width - lastOffsetX || item.screen_x + DragOffsetX < 0 || item.screen_x + DragOffsetX < 0 || item.screen_y + DragOffsetY > canvas.height)) {
                            labelData.splice(i, 1)
                            i--;
                            continue;
                        }
                        if (item.type == "Vector") {
                            var newoffsetx = -lastOffsetX - DragOffsetX;
                            var newoffsety = -lastOffsetY - DragOffsetY;
                            if (newoffsetx < 0) {
                                newoffsetx = 256 - (-newoffsetx) % 256;
                            }
                            else {
                                newoffsetx = newoffsetx % 256;
                            }
                            if (newoffsety < 0) {
                                newoffsety = 256 - (-newoffsety) % 256;
                            }
                            else {
                                newoffsety = newoffsety % 256;
                            }

                            item.screen_x = item.screen_x + lastOffsetX + DragOffsetX + newoffsetx;
                            item.screen_y = item.screen_y + lastOffsetY + DragOffsetY + newoffsety;
                            if (item.screen_x < 0 || item.screen_x > canvas.width || item.screen_y < 0 || item.screen_y > canvas.width) {
                                labelData.splice(i, 1)
                                i--;
                            }
                        }
                    }
                }
                else {
                    for (var i = 0; i < labelData.length; i++) {
                        if (labelData[i].layerId != layerId)
                            continue
                        var item = labelData[i];
                        if (item.type == "Vector") {
                            item.screen_x = item.screen_x + DragOffsetX;
                            item.screen_y = item.screen_y + DragOffsetY;
                            if (item.screen_x < 0 || item.screen_x > canvas.width || item.screen_y < 0 || item.screen_y > canvas.width) {
                                labelData.splice(i, 1)
                                i--;
                            }
                        }
                    }
                }

            }
        },
        /**
        * label图层偏移
        * @param {*} layerId 图层Id
        */
        labelCanvasoffset(layerId) {
            var layerInfo = store.state.allLayerData.find(x => x.Id == layerId);
            if (layerInfo == undefined) {
                return;
            }
            var rowcol = getRowCol(map.extent);
            var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
            //?
            var canvas = document.getElementById("labelLayer_" + layerId);
            if (canvas) {
                if (layerInfo.GeoType == "点") {
                    //点画布                  
                    canvas.style.left = offset.offsetX + "px";
                    canvas.style.top = offset.offsetY + "px";
                } else {
                    canvas.style.left = "0px";
                    canvas.style.top = "0px";
                }
            }
        },
        /**
        * @author: wyt
        * @description:添加标注
        * @param {*} attrField 属性
        * @param {*} currentLayerLabel 当前lable图层
        * @param {*} currentLayer 当前图层
        * @param {*} targetGraphic
        * @param {*} Id 要素Id
        */
        addLabel(
            attrField,
            currentLayerLabel,
            currentLayer,
            targetGraphic,
            Id
        ) {
            let esriModule = store.state.esriModule;
            var point;
            if (attrField != undefined) {
                var symbol = new esriModule.TextSymbol({
                    text: attrField,
                    color: currentLayerLabel.graphics[0].symbol.color
                });
                symbol.setFont(currentLayerLabel.graphics[0].symbol.font);
                symbol.setHaloColor(currentLayerLabel.graphics[0].symbol.haloColor);
                symbol.setHaloSize(currentLayerLabel.graphics[0].symbol.haloSize);

                if (currentLayer.geometryType == "esriGeometryPoint") {
                    point = new esriModule.Point(
                        targetGraphic.geometry.x,
                        targetGraphic.geometry.y,
                        map.spatialReference
                    );
                } else if (currentLayer.geometryType == "esriGeometryPolyline") {
                    var x = targetGraphic.geometry.paths[0][0][0];
                    var y = targetGraphic.geometry.paths[0][0][1];
                    point = new esriModule.Point(x, y, map.spatialReference);
                } else {
                    var x = (targetGraphic._extent.xmax + targetGraphic._extent.xmin) / 2;
                    var y = (targetGraphic._extent.ymax + targetGraphic._extent.ymin) / 2;
                    point = new esriModule.Point(x, y, map.spatialReference);
                }
                var LabelGraphic = new esriModule.Graphic(point, symbol, {
                    ID: Id
                });
                currentLayerLabel.add(LabelGraphic);
            }
        },
        /**
         * @author: wyt
         * @description: 设置label
         * @export
         * @param {*} layerId 图层Id
         * @param {*} AttrObj 属性
         * @param {*} Id 要素Id
         */
        setLabel(layerId, AttrObj, Id) {
            let esriModule = store.state.esriModule;
            let currentLayerLabel,
                labelField = "",
                currentLayer;
            if (layerId == "taskExtent") {
                currentLayerLabel = taskTextGraphicLayer;
                labelField = "Name";
                currentLayer = map.getLayer(layerId);
            } else {
                currentLayerLabel = map.getLayer(layerId + "_Label");
                var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
                var currentLayerData = vectorLayerData.filter(item => {
                    return item.id == layerId;
                });
                labelField = currentLayerData[0].labelField;
                currentLayer = map.getLayer("dataLayer_" + layerId);
            }
            if (currentLayerLabel != undefined) {
                var flag = false;
                if (currentLayerLabel.graphics.length > 0) {
                    for (var i = 0; i < currentLayerLabel.graphics.length; i++) {
                        if (Id == currentLayerLabel.graphics[i].attributes.ID) {
                            var symbol = currentLayerLabel.graphics[i].symbol;
                            flag = true;
                            if (labelField != "") {
                                if (AttrObj[labelField]) {
                                    var Value = AttrObj[labelField];
                                    symbol.setText(Value);
                                }
                            }
                        }
                    }
                    if (!flag) {
                        let targetGraphic = currentLayer.graphics.find(ele => {
                            return ele.attributes.ID == Id;
                        });
                        addLabel(
                            AttrObj[labelField],
                            currentLayerLabel,
                            currentLayer,
                            targetGraphic,
                            Id
                        );
                    }
                }
                currentLayerLabel.redraw();
            }
        },
        /**
         * @author: wyt
         * @description:删除标注
         * @param {*} currentLayerLabel label图层
         * @param {*} Id 要素Id
         */
        deleteLabel(currentLayerLabel, Id) {
            if (currentLayerLabel != undefined) {
                if (currentLayerLabel.graphics.length > 0) {
                    let index = -1;
                    index = currentLayerLabel.graphics.findIndex(ele => {
                        return Id == ele.attributes.ID;
                    });
                    if (index > -1) {
                        currentLayerLabel.remove(currentLayerLabel.graphics[index]);
                    }
                }
            }
        },
        /**
 * @author: wyt
 * @description: 添加label
 * @export
 * @param {*} layerId 图层id
 * @param {*} GeoType 数据类型
 * @param {*} LabelInfo label数据
 */
        getLabelGraphic(layerId, GeoType, LabelInfo) {
            var esriModule = store.state.esriModule;
            var LabelGraphicLayer = map.getLayer(layerId + "_Label");
            var CurrentLayer = map.getLayer("dataLayer_" + layerId);
            if (LabelGraphicLayer != undefined) {
                if (LabelGraphicLayer.graphics.length > 0) {
                    LabelGraphicLayer.clear();
                }
            }
            var LabelGraphic;
            if (CurrentLayer.graphics.length > 0) {
                for (var i = 0; i < CurrentLayer.graphics.length; i++) {
                    if (
                        CurrentLayer.graphics[i].attributes.hasOwnProperty(LabelInfo.LabelField)
                    ) {
                        var LabelSymbol = new esriModule.TextSymbol({
                            text: CurrentLayer.graphics[i].attributes[LabelInfo.LabelField],
                            font: new esriModule.Font({
                                size: LabelInfo.font.size,
                                family: LabelInfo.font.family,
                                weight: LabelInfo.font.weight
                            }),
                            color: LabelInfo.color
                        });
                        LabelSymbol.setHaloSize(LabelInfo.haloSize ? LabelInfo.haloSize : 0);
                        if (LabelInfo.haloColor != undefined) {
                            LabelSymbol.setHaloColor(
                                new esriModule.Color([
                                    LabelInfo.haloColor.r,
                                    LabelInfo.haloColor.g,
                                    LabelInfo.haloColor.b,
                                    LabelInfo.haloColor.a
                                ])
                            );
                        } else {
                            LabelSymbol.setHaloColor(new esriModule.Color([255, 255, 255, 1]));
                        }
                        var point;
                        if (GeoType == "点") {
                            point = new esriModule.Point(
                                CurrentLayer.graphics[i].geometry.x,
                                CurrentLayer.graphics[i].geometry.y,
                                map.spatialReference
                            );
                            LabelSymbol.setOffset(12, 12);
                        } else if (GeoType == "线") {
                            var x = CurrentLayer.graphics[i].geometry.paths[0][0][0];
                            var y = CurrentLayer.graphics[i].geometry.paths[0][0][1];
                            point = new esriModule.Point(x, y, map.spatialReference);
                            LabelSymbol.setOffset(12, 12);
                        } else {
                            var x =
                                (CurrentLayer.graphics[i].geometry.cache._extent.xmax +
                                    CurrentLayer.graphics[i].geometry.cache._extent.xmin) /
                                2;
                            var y =
                                (CurrentLayer.graphics[i].geometry.cache._extent.ymax +
                                    CurrentLayer.graphics[i].geometry.cache._extent.ymin) /
                                2;
                            point = new esriModule.Point(x, y, map.spatialReference);
                        }
                        LabelGraphic = new esriModule.Graphic(
                            point,
                            LabelSymbol,
                            CurrentLayer.graphics[i].attributes
                        );
                        LabelGraphicLayer.add(LabelGraphic);
                    }
                }
                //可见比例尺
                var allLayerData = store.state.allLayerData;
                var tmpData = allLayerData.find(item => {
                    return item.Id == layerId;
                });
                // LabelGraphicLayer.setMaxScale(parseInt(tmpData.MaxScale));
                // LabelGraphicLayer.setMinScale(parseInt(tmpData.MinScale));
                var scale = map.getScale();
                var flag = isInScale(layerId);
                if (flag == false) {
                    LabelGraphicLayer.show();
                } else if (flag == "hide" || flag == true) {
                    LabelGraphicLayer.hide();
                }
                // if (parseInt(tmpData.MinScale) != 0 && parseInt(tmpData.MaxScale) != 0) {
                //     if (scale <= parseInt(tmpData.MinScale) && scale >= parseInt(tmpData.MaxScale)) {
                //         LabelGraphicLayer.show();
                //     } else {
                //         LabelGraphicLayer.hide()
                //     }
                // }

                if (getPageType() != 4) {
                    let isShow = initLayerVisible(LayerName);
                    if (isShow && LabelInfo.Visiable) {
                        LabelGraphicLayer.show();
                    } else {
                        LabelGraphicLayer.hide();
                    }
                }
            }
        }

    }
